module.exports = __webpack_public_path__ + "static/media/brand-icon.34c44eea.png";